import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
  faMobile, 
  faEnvelope, 
  faUser, 
  faExclamationCircle,
  faDivideLines
} from '@fortawesome/free-solid-svg-icons';
import { faGoogle } from '@fortawesome/free-brands-svg-icons';
import { useTranslation } from 'react-i18next';
import Header from '../../components/Header';
import GoogleLogin from '../../components/GoogleLogin';
import GoogleSDKTest from '../../components/GoogleSDKTest';
import GoogleLoginSimple from '../../components/GoogleLoginSimple';
import '../../styles/AuthPages.css';

const UnifiedLogin = () => {
  const [error, setError] = useState('');
  const { t } = useTranslation();

  const handleGoogleError = (errorMessage) => {
    setError(errorMessage);
  };

  return (
    <div className="home-page">
      <Header />
      <div className="auth-container">
        <div className="auth-header">
          <h1>{t('login.title')}</h1>
          <p>{t('login.subtitle')}</p>
        </div>
        
        {error && (
          <div className="auth-error">
            <FontAwesomeIcon icon={faExclamationCircle} /> {error}
          </div>
        )}

        <div className="login-options">
          {/* Google SDK测试组件 - 临时调试用 */}
          {/* <GoogleSDKTest /> */}

          {/* 简化Google登录测试 */}
          <GoogleLoginSimple />

          {/* Google登录 */}
          {/* <div className="auth-section">
            <h3>
              <FontAwesomeIcon icon={faGoogle} style={{ color: '#db4437' }} />
              Google 快速登录
            </h3>
            <GoogleLoginSimple />
          </div> */}
          
          {/* 分隔线 */}
          <div className="divider">
            <span>{t('login.or')}</span>
          </div>

          {/* 其他登录选项 */}
          <div className="login-methods">
            {/* <Link to="/mobileregister" className="login-method-btn mobile-login" onclick="return false;" isDisabled>
              <FontAwesomeIcon icon={faMobile} className="method-icon" />
              <div className="method-content">
                <div className="method-title">手机号登录</div>
                <div className="method-desc">使用手机验证码快速登录</div>
              </div>
            </Link> */}
            <Link
              to="#"
              onClick={(e) => e.preventDefault()} // 阻止默认跳转
              className="login-method-btn mobile-login disabled-link"
            >
              <FontAwesomeIcon icon={faMobile} className="method-icon" />
              <div className="method-content">
                <div className="method-title">{t('login.phoneLogin')}</div>
                <div className="method-desc">{t('login.phoneLoginDesc')}</div>
              </div>
            </Link>

            {/* <Link to="/email-register" className="login-method-btn email-login"> */}
            <Link to="/emailregister" className="login-method-btn email-login">
              <FontAwesomeIcon icon={faEnvelope} className="method-icon" />
              <div className="method-content">
                <div className="method-title">{t('login.emailLogin')}</div>
                <div className="method-desc">{t('login.emailLoginDesc')}</div>
              </div>
            </Link>

            <Link to="/uplogin" className="login-method-btn account-login">
              <FontAwesomeIcon icon={faUser} className="method-icon" />
              <div className="method-content">
                <div className="method-title">{t('login.accountLogin')}</div>
                <div className="method-desc">{t('login.accountLoginDesc')}</div>
              </div>
            </Link>
          </div>
        </div>

        <div className="auth-links">
          <Link to="/register">{t('login.register')}</Link>
        </div>
      </div>
    </div>
  );
};

export default UnifiedLogin; 